import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';

export class DashBoardDeclaration {
    static jsonMap = {
        dateDeclaration: { key: 'dateDeclaration', converter: new DateConverter() },
        codeMouvement: 'codeMouvement'
    };

    dateDeclaration: moment.Moment;
    codeMouvement: string;
}
